import { CategoryIcons } from '@/components/icons/CategoryIcons';
import { Picture } from '@/components/image/Image';
import { Product } from '@/services/api/contracts/catalog/types';
import { FC } from 'react';

interface ProductImageProps {
  product: Product;
}

export const StockLevelProductImage: FC<ProductImageProps> = ({ product }) => {
  return product.imageUri?.id ? (
    <div className="w-full h-[100px] flex items-center justify-center">
      <Picture image={product.imageUri} containerHeight={100} containerWidth={125}></Picture>
    </div>
  ) : (
    <div className="w-full h-[100px] [&_svg]:w-[100%] [&_svg]:h-[100%]">
      {CategoryIcons[product.category.description]}
    </div>
  );
};
